import locale from './date-picker';
export default locale;



// WEBPACK FOOTER //
// ./src/locale/hr_HR/calendar.ts